export default __webpack_public_path__ + "static/media/ham-c.8ab7632d.svg";